import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { NModal, NCard } from "naive-ui";
import { ref, watch } from "vue";

interface IProps {
  isOpen: boolean;
  title: string;
  message: string;
  positiveText?: string;
  negativeText?: string;
  type?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogConfirm',
  props: {
    isOpen: { type: Boolean, default: false },
    title: {},
    message: {},
    positiveText: { default: "Confirm" },
    negativeText: {},
    type: { default: "success" }
  },
  emits: ["onCancel", "onConfirm"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const show = ref(props.isOpen);

watch(props, (val) => {
  show.value = val.isOpen;
});

function onConfirm() {
  show.value = false;
  emit("onConfirm", show.value);
}

function onCancel() {
  show.value = false;
  emit("onCancel", show.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NModal), {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    preset: "dialog",
    type: _ctx.type,
    title: _ctx.title,
    "positive-text": _ctx.positiveText,
    "negative-text": _ctx.negativeText,
    onMaskClick: onCancel,
    onClose: onCancel,
    onPositiveClick: onConfirm,
    onNegativeClick: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { innerHTML: _ctx.message }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["show", "type", "title", "positive-text", "negative-text"]))
}
}

})